<template>
  <div style="background: #fff">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.strategy')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.traffic')
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="title">
        <h2>{{ getTitle('header.traffic') }}</h2>
      </div>
      <div class="traffic-routes">
        <div class="left">
          <baidu-map
            class="bm-view"
            ak="f3IyDThmG29VKfNf0uRpA0RKV9IlfRE3"
            :center="center"
            :zoom="zoom"
            @ready="handler"
          >
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          </baidu-map>
        </div>
        <div class="right">
          <el-tabs
            class="guide-tabs routes-way"
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-tab-pane
              :label="content02[0] ? content02[0].title : ''"
              name="first"
            >
              <div v-html="content02[0] ? content02[0].content : ''"></div>
            </el-tab-pane>
            <el-tab-pane
              :label="content03[0] ? content03[0].title : ''"
              name="second"
            >
              <div v-html="content03[0] ? content03[0].content : ''"></div>
            </el-tab-pane>
            <el-tab-pane
              :label="content04[0] ? content04[0].title : ''"
              name="third"
            >
              <div v-html="content04[0] ? content04[0].content : ''"></div>
            </el-tab-pane>
            <el-tab-pane
              :label="content05[0] ? content05[0].title : ''"
              name="fourth"
            >
              <div v-html="content05[0] ? content05[0].content : ''"></div>
            </el-tab-pane>
          </el-tabs>
          <div
            class="tips"
            v-html="content01[0] ? content01[0].content : ''"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import _ from 'underscore';
import { BaiduMap, BmNavigation } from 'vue-baidu-map/components';
export default {
  components: {
    BaiduMap,
    BmNavigation,
  },
  data() {
    return {
      activeName: 'first',
      contentList: [],
      center: { lng: 0, lat: 0 },
      zoom: 3,
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    content01() {
      return this.localeContent01(this.locale);
    },
    content02() {
      return this.localeContent02(this.locale);
    },
    content03() {
      return this.localeContent03(this.locale);
    },
    content04() {
      return this.localeContent04(this.locale);
    },
    content05() {
      return this.localeContent05(this.locale);
    },
  },
  async created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    await this.getContentList();
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    handler({ BMap, map }) {
      console.log(BMap, map);
      this.center.lng = 128.249756;
      this.center.lat = 43.325273;
      this.zoom = 15;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    async getContentList() {
      const getContentList = await www.getContentList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        category: '3',
        page_size: '100',
      });
      this.contentList = getContentList.data;
    },
    localeContent01(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('content.info02.title')
        );
      });
    },
    localeContent02(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('content.info03.title')
        );
      });
    },
    localeContent03(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('content.info04.title')
        );
      });
    },
    localeContent04(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('content.info05.title')
        );
      });
    },
    localeContent05(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('content.info06.title')
        );
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrapper {
  width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  text-align: left;
  .title {
    padding: 40px 0;
    text-align: center;
    h2 {
      color: #191b26;
      font-weight: normal;
      font-size: 30px;
      line-height: 42px;
    }
  }
  .traffic-routes {
    display: flex;
    margin-bottom: 60px;
    position: relative;
    border-radius: 10px;
    background: #f8f8f8;
    .left {
      width: 330px;
      z-index: 20;
      line-height: 0;
      img {
        max-width: 100%;
      }
      .bm-view {
        width: 330px;
        height: 620px;
        /deep/ div {
          border-radius: 10px 0 0 10px;
        }
        /deep/ .BMap_stdMpCtrl {
          // inset: 20px auto auto 20px !important;
          left: 10px !important;
        }
        /deep/ .BMap_cpyCtrl {
          display: none;
        }
        /deep/ .anchorBL {
          display: none;
        }
      }
    }
    .right {
      width: 770px;
      padding: 40px 20px 90px 20px;
      .routes-way {
        line-height: 28px;
      }
      .tips {
        padding: 16px 0 16px 350px;
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 0 0 10px 10px;
        color: #f2481c;
        line-height: 24px;
        background: #eee;
      }
    }
  }
  .content {
    margin-bottom: 20px;
    padding: 60px 80px;
    border-radius: 10px;
    font-size: 16px;
    line-height: 32px;
    background: #f6fcf9;
    img {
      max-width: 100%;
      margin-bottom: 24px;
    }
    p {
      margin-bottom: 24px;
      text-align: justify;
    }
  }
}
.guide-tabs /deep/ .el-tabs__header {
  margin: 0 0 20px;
}
.guide-tabs /deep/ .el-tabs__nav-wrap::after {
  height: 0;
  background: none;
}
.guide-tabs /deep/ .el-tabs__nav {
  border: none;
}
.guide-tabs /deep/ .el-tabs__item {
  width: 162px;
  height: 40px;
  margin-right: 20px;
  padding: 0 !important;
  border: none;
  color: #515457;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  background: url(../../assets/images/bg-tabs-item.png) no-repeat 50% 50%;
  background-size: 162px 40px;
}
.guide-tabs /deep/ .el-tabs__item.is-active {
  color: #fff;
  background: url(../../assets/images/bg-tabs-item-green.png) no-repeat 50% 50%;
  background-size: 162px 40px;
}
.guide-tabs /deep/ .el-tabs__active-bar {
  height: 0;
  background: none;
}
.routes-way /deep/ .el-tabs__item.is-active {
  background: url(../../assets/images/bg-tabs-item-blue.png) no-repeat 50% 50%;
  background-size: 162px 40px;
}
</style>
